import _ from 'lodash';
import { translate } from '../utils/translate/translations';
import fetchWithCache from './fetchWithCache';

const normalizeResponse = (data) => {
  _.forEach(data.groups, (values) => {
    _.forEach(values, (x, key) => {
      if (!x.disclosure) {
        x.disclosure =
          key === '26' || key === '27'
            ? translate('fuel.efficiency.disclosure')
            : '';
      }
    });
  });
  return data;
};

const fetchCapabilities = ({ v3ServicesPath, modelPath }) => {
  const url = `${v3ServicesPath}/engine-compare/comparison/${modelPath}`;
  return fetchWithCache(url).then(normalizeResponse);
};

export default fetchCapabilities;
